const guiColors = {
    'motion-primary': '#3a3a3a', // Deep Titanium Gray
    'motion-primary-transparent': '#3a3a3ae6',
    'motion-tertiary': '#252525', // Darker Matte Gray

    'looks-secondary': '#4a4a4a', // Medium Gray
    'looks-transparent': '#4a4a4a59',
    'looks-light-transparent': '#4a4a4a26',
    'looks-secondary-dark': 'hsla(0, 0%, 25%, 1)',

    'extensions-primary': 'hsla(0, 0%, 50%, 1)', // Neutral Gray
    'extensions-tertiary': 'hsla(0, 0%, 30%, 1)',
    'extensions-transparent': 'hsla(0, 0%, 50%, 0.35)',
    'extensions-light': 'hsla(0, 0%, 80%, 1)',

    'drop-highlight': '#666666' // Visible Gray Highlight
};

const blockColors = {
    checkboxActiveBackground: '#3a3a3a',
    checkboxActiveBorder: '#252525'
};

export {
    guiColors,
    blockColors
};
